import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { AppRoutingModule } from './app.routing.module';
import { DialogsModule } from '@migo-apps/dialogs';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { SessionInterceptor } from '@authentication';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import '@angular/common/locales/global/es-GT';
import { MatNativeDateModule } from '@angular/material/core';
import { HttpErrorInterceptor } from './shared/interceptors/http-error.interceptor';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';

import { ComponentsModule } from '@migo-apps/components';
import { InputComponent } from '@migo-apps/migo-uikit-v4';
// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    DialogsModule,
    HttpClientModule,
    MatSnackBarModule,
    MatNativeDateModule,
    TranslateModule.forRoot({
      defaultLanguage: 'es',
      useDefaultLang: true,
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader,
      },
    }),
    ComponentsModule,
    InputComponent,
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: {
        prefix: 'assets/i18n/',
        suffix: '.json',
      },
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SessionInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'es-GT',
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => null,
      multi: true,
    },
  ],
})
export class AppModule {}
